import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { ThemeMode } from "../../../util/theme";
import { chipCustomCssProperties } from "./chipConstants";
import { chipTheme } from "./chipTheme";

interface ChipContainerProps {
    isReadonly: boolean;
    size: "small" | "medium";
    themeMode: ThemeMode;
}

export const ChipContainer = styled("div")<ChipContainerProps>`
    box-sizing: border-box;
    height: ${({ size, themeMode }) => chipTheme.height[size](themeMode)};
    padding-left: 4px;
    padding-right: 4px;

    border-radius: ${({ themeMode }) => chipTheme.borderRadius(themeMode)};

    display: inline-flex;
    flex-direction: row;
    align-items: center;
    cursor: default;

    max-width: 100%;
    transition: ${({ themeMode }) => chipTheme.motion.animation(themeMode)};

    // TODO if we extract these 4 token usages behind 4 css properties private to the Chip, we can
    // set those in the component's render and not have to create a unique className for each of
    // these variants.
    color: var(${chipCustomCssProperties.text});
    background-color: var(${chipCustomCssProperties.backgroundRest});

    ${({ isReadonly }) => {
        if (!isReadonly) {
            return `
                    :hover {
                        background-color: var(${chipCustomCssProperties.backgroundHover});
                    }

                    :active {
                        background-color: var(${chipCustomCssProperties.backgroundActive});
                    }
            `;
        }
    }}

    ${({ themeMode }) =>
        createFocusRingStyles({
            theme: themeMode,
            // Place the ring just inside the content box.
            gap: -2,
            componentBorderWidth: 0,
            componentRadius: chipTheme.borderRadius(themeMode),
            focusSelector: ":focus-visible",
        })}
`;
